import clsx from 'clsx'

interface Props {
  label: string
  value: string
  hint?: string
  warning?: boolean
  accent?: 'gold' | 'blue' | 'red' | 'gray'
}

export function KpiCard({ label, value, hint, warning, accent }: Props) {
  const borderColor =
    accent === 'red' || warning ? 'border-l-red-500' :
    accent === 'blue'           ? 'border-l-kh-blue' :
    accent === 'gray'           ? 'border-l-kh-gray-300' :
                                  'border-l-kh-gold'
  const valueColor = warning ? 'text-red-600' : 'text-kh-gray-800'

  return (
    <div className={clsx('card p-5 border-l-4', borderColor)}>
      <p className="text-xs uppercase tracking-wider text-kh-gray-500 font-medium">
        {label}
      </p>
      <p className={clsx('text-2xl font-semibold mt-1', valueColor)}>
        {value}
      </p>
      {hint && <p className="text-xs text-kh-gray-400 mt-1">{hint}</p>}
    </div>
  )
}
